module.exports = __webpack_public_path__ + "04_mid_brown.2bd38b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_mid_brown.png
// module id = sPEy
// module chunks = 0